import RewardList from "./RewardList";

export default RewardList;
